<template>
    <v-footer dark padless>
        <v-card flat tile class="secondary white--text text-center full-width">
           <!-- <v-card-text>
               <v-btn v-for="icon in icons" :key="icon" class="mx-4 white&#45;&#45;text" icon>
                   <v-icon size="24px">
                       {{ icon }}
                   </v-icon>
               </v-btn>
           </v-card-text> -->

            <v-card-text class="white--text">
                <span id="tenp">tenpredict</span> - The web's best football prediction game!
            </v-card-text>

            <v-divider></v-divider>

            <v-card-text class="white--text">
                ©{{ new Date().getFullYear() }} — <strong>Bert Igler</strong><br />
                <span id="footer-rob">Designed and built by Rob Holloway</span>
            </v-card-text>
        </v-card>
    </v-footer>
</template>

<script>

  export default {
    name: "FooterComponent",
    data () {
      return {
        icons: [
          'mdi-facebook',
          'mdi-twitter',
          'mdi-instagram',
        ],
      }
    },
  }
</script>

<style scoped>

    .full-width {
        width: 100%;
    }

    #tenp {
        font-family: "Montserrat-SemiBold";
    }

    #footer-rob {
        font-family: "Barlow-Light";
    }

</style>
